import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from 'web-ui-components/lib/molecules/nbas';

const CancelPaymentLayout = ({ children, cancelPaymentAlert, cancelPaymentSubHeader }) => (
	<div>
		<p>{cancelPaymentSubHeader}</p>
		{cancelPaymentAlert && (
			<div className="u-margin-bottom-2">
				<Alert type="info">{cancelPaymentAlert}</Alert>
			</div>
		)}
		{children}
	</div>
);
CancelPaymentLayout.propTypes = {
	cancelPaymentAlert: PropTypes.string.isRequired,
	cancelPaymentSubHeader: PropTypes.string,
	children: PropTypes.element.isRequired,
};

export default CancelPaymentLayout;
